import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { RequestStatus } from '@lib/plugin-redux-core';
import { GET_CONVERSATIONS_WITH_MESSAGES_USE_CASE, GET_MESSAGES_USE_CASE, CREATE_CONVERSATION_USE_CASE, GET_LLM_PROVIDERS_USE_CASE, GET_PROMPT_TEMPLATES_USE_CASE, Message, SEND_MESSAGE_USE_CASE, MessageRole, MessageContent, MessageTimestamp, MessageStatus, STOP_MESSAGE_USE_CASE, UPLOAD_CONVERSATION_FILES_USE_CASE } from '../../../../ai';
import { CREATE_AI_ATTACHMENT_FILES_USE_CASE, VALIDATE_PUBLIC_FILE_URL_USE_CASE } from '../../../../file-storage';
import { UniqueEntityID } from '@digibricks/core';
import { APPEND_AI_MESSAGE_ON_STREAM_DONE, ADD_STOPPED_MESSAGE, STREAM_CHAT_USE_CASE, ADD_ATTACHMENTS, REMOVE_ATTACHMENT, CLEAR_ATTACHMENTS, GET_AI_CHAT_USAGE_WALLET_USE_CASE, GET_AI_CHAT_ACCOUNTING_SUBSCRIPTION_USE_CASE } from './ai-chat.action';

/**
 * Handler for geting conversations use case
 */
export var handleGetConversationsWithMessagesUseCase = {
  name: GET_CONVERSATIONS_WITH_MESSAGES_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      getConversationsWithMessagesStatus: RequestStatus.EXECUTE
    });
  },
  success: function success(state, action) {
    var payload = action.payload;

    var _ref = payload,
        _ref2 = _slicedToArray(_ref, 3),
        conversation = _ref2[0],
        messages = _ref2[1],
        nextToken = _ref2[2];

    return _objectSpread(_objectSpread({}, state), {}, {
      currentConversationId: conversation.id.toString(),
      messages: messages,
      messagesNextToken: nextToken !== null && nextToken !== void 0 ? nextToken : null,
      getConversationsWithMessagesStatus: RequestStatus.SUCCESS
    });
  },
  error: function error(state, action) {
    var error = action.error;
    return _objectSpread(_objectSpread({}, state), {}, {
      getConversationsWithMessagesStatus: RequestStatus.ERROR,
      error: error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      getConversationsWithMessagesStatus: RequestStatus.RESET
    });
  }
};
/**
 * Handler for geting messages use case
 */

export var handleGetMessagesUseCase = {
  name: GET_MESSAGES_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      getMessagesStatus: RequestStatus.EXECUTE
    });
  },
  success: function success(state, action) {
    var _pagination$items, _pagination$nextToken;

    var payload = action.payload;
    var pagination = payload;
    var newItems = (_pagination$items = pagination === null || pagination === void 0 ? void 0 : pagination.items) !== null && _pagination$items !== void 0 ? _pagination$items : [];
    return _objectSpread(_objectSpread({}, state), {}, {
      messages: [].concat(_toConsumableArray(newItems), _toConsumableArray(state.messages)),
      messagesNextToken: (_pagination$nextToken = pagination === null || pagination === void 0 ? void 0 : pagination.nextToken) !== null && _pagination$nextToken !== void 0 ? _pagination$nextToken : null,
      getMessagesStatus: RequestStatus.SUCCESS
    });
  },
  error: function error(state, action) {
    var error = action.error;
    return _objectSpread(_objectSpread({}, state), {}, {
      getMessagesStatus: RequestStatus.ERROR,
      error: error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      messages: [],
      messagesNextToken: null,
      getMessagesStatus: RequestStatus.RESET
    });
  }
};
export var handleGetPromptTemplatesUseCase = {
  name: GET_PROMPT_TEMPLATES_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      promptTemplatesStatus: RequestStatus.EXECUTE
    });
  },
  success: function success(state, action) {
    var _pagination$items2;

    var pagination = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      promptTemplatesStatus: RequestStatus.SUCCESS,
      promptTemplates: (_pagination$items2 = pagination === null || pagination === void 0 ? void 0 : pagination.items) !== null && _pagination$items2 !== void 0 ? _pagination$items2 : []
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      promptTemplatesStatus: RequestStatus.ERROR,
      error: action.error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      promptTemplatesStatus: RequestStatus.RESET,
      promptTemplates: []
    });
  }
};
export var handleGetLlmProvidersUseCase = {
  name: GET_LLM_PROVIDERS_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      llmProvidersStatus: RequestStatus.EXECUTE
    });
  },
  success: function success(state, action) {
    var _pagination$items3;

    var pagination = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      llmProvidersStatus: RequestStatus.SUCCESS,
      llmProviders: (_pagination$items3 = pagination === null || pagination === void 0 ? void 0 : pagination.items) !== null && _pagination$items3 !== void 0 ? _pagination$items3 : []
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      llmProvidersStatus: RequestStatus.ERROR,
      error: action.error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      llmProvidersStatus: RequestStatus.RESET,
      llmProviders: []
    });
  }
};
export var handleGetAIChatUsageWalletUseCase = {
  name: GET_AI_CHAT_USAGE_WALLET_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      usageWalletStatus: RequestStatus.EXECUTE,
      usageWallet: null
    });
  },
  success: function success(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      usageWalletStatus: RequestStatus.SUCCESS,
      usageWallet: action.payload
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      usageWalletStatus: RequestStatus.ERROR,
      error: action.error,
      usageWallet: null
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      usageWalletStatus: RequestStatus.RESET,
      usageWallet: null
    });
  }
};
export var handleGetAIChatAccountingSubscriptionUseCase = {
  name: GET_AI_CHAT_ACCOUNTING_SUBSCRIPTION_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      accountingSubscriptionStatus: RequestStatus.EXECUTE,
      accountingSubscription: null
    });
  },
  success: function success(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      accountingSubscriptionStatus: RequestStatus.SUCCESS,
      accountingSubscription: action.payload
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      accountingSubscriptionStatus: RequestStatus.ERROR,
      error: action.error,
      accountingSubscription: null
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      accountingSubscriptionStatus: RequestStatus.RESET,
      accountingSubscription: null
    });
  }
};
/**
 * Handler for sending message use case
 */

export var handleSendMessageUseCase = {
  name: SEND_MESSAGE_USE_CASE,
  executing: function executing(state, action) {
    var payload = action.payload; // append user message to messages

    var userMessage = payload;
    var newUserMessage = Message.create({
      content: MessageContent.create(userMessage.content).getValue(),
      role: MessageRole.User,
      conversationId: userMessage.conversationId,
      userId: userMessage.userId,
      modelId: userMessage.modelId,
      data: userMessage.data,
      id: new UniqueEntityID().toString(),
      createdTime: MessageTimestamp.now(),
      status: MessageStatus.Active
    }).getValue();
    return _objectSpread(_objectSpread({}, state), {}, {
      sendMessageStatus: RequestStatus.EXECUTE,
      messages: [].concat(_toConsumableArray(state.messages), [newUserMessage])
    });
  },
  success: function success(state, action) {
    var _output$messageId;

    var payload = action.payload;
    var output = payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      sendMessageStatus: RequestStatus.SUCCESS,
      sendMessageOutput: output,
      currentMessageId: (_output$messageId = output === null || output === void 0 ? void 0 : output.messageId) !== null && _output$messageId !== void 0 ? _output$messageId : null
    });
  },
  error: function error(state, action) {
    var error = action.error;
    return _objectSpread(_objectSpread({}, state), {}, {
      sendMessageStatus: RequestStatus.ERROR,
      error: error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sendMessageStatus: RequestStatus.RESET
    });
  }
};
/**
 * Handler for streaming chat use case
 */

export var handleStreamChatUseCase = {
  name: STREAM_CHAT_USE_CASE,
  executing: function executing(state, action) {
    var payload = action.payload;
    var messageId = (payload === null || payload === void 0 ? void 0 : payload.messageId) || null;
    return _objectSpread(_objectSpread({}, state), {}, {
      isStreaming: true,
      streamingMessageId: messageId,
      streamingContent: '',
      streamChatStatus: RequestStatus.EXECUTE
    });
  },
  success: function success(state, action) {
    var payload = action.payload;
    var message = payload; // Set AI message status to Streaming when stream starts

    if (message.role === MessageRole.AIAssistant) {
      message.updateStatus(MessageStatus.Streaming);
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      isStreaming: false,
      streamingMessageId: null,
      streamingContent: '',
      messages: [].concat(_toConsumableArray(state.messages), [message]),
      streamChatStatus: RequestStatus.SUCCESS
    });
  },
  error: function error(state, action) {
    var error = action.error;
    return _objectSpread(_objectSpread({}, state), {}, {
      isStreaming: false,
      streamingMessageId: null,
      streamingContent: '',
      streamChatStatus: RequestStatus.ERROR,
      error: error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isStreaming: false,
      streamingMessageId: null,
      streamingContent: '',
      streamChatStatus: RequestStatus.RESET
    });
  }
};
/**
 * Handler: append AI message to state when stream is done (create last message, then stream text from full content in UI)
 * Both executing and success so reducer runs whether plugin invokes executing or success for this action type.
 */

var appendMessageOnStreamDone = function appendMessageOnStreamDone(state, action) {
  var _state$messages;

  var message = action.payload;
  var messages = (_state$messages = state.messages) !== null && _state$messages !== void 0 ? _state$messages : []; // Set AI message status to Done when stream completes

  if (message.role === MessageRole.AIAssistant) {
    message.updateStatus(MessageStatus.Done);
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    messages: [].concat(_toConsumableArray(messages), [message])
  });
};

export var handleAppendAiMessageOnStreamDone = {
  name: APPEND_AI_MESSAGE_ON_STREAM_DONE,
  executing: appendMessageOnStreamDone,
  success: appendMessageOnStreamDone
};
/**
 * Handler for adding stopped message
 */

export var handleAddStoppedMessage = {
  name: ADD_STOPPED_MESSAGE,
  executing: function executing(state, action) {
    var _state$messages2;

    var stoppedMessage = action.payload;
    var messages = (_state$messages2 = state.messages) !== null && _state$messages2 !== void 0 ? _state$messages2 : []; // Check if last message is already a stopped message to prevent duplicates

    var lastMessage = messages[messages.length - 1];

    if (lastMessage && lastMessage.status === MessageStatus.Stopped) {
      return state; // Don't add duplicate stopped message
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      messages: [].concat(_toConsumableArray(messages), [stoppedMessage])
    });
  },
  success: function success(state, action) {
    var _state$messages3;

    var stoppedMessage = action.payload;
    var messages = (_state$messages3 = state.messages) !== null && _state$messages3 !== void 0 ? _state$messages3 : []; // Check if last message is already a stopped message to prevent duplicates

    var lastMessage = messages[messages.length - 1];

    if (lastMessage && lastMessage.status === MessageStatus.Stopped) {
      return state; // Don't add duplicate stopped message
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      messages: [].concat(_toConsumableArray(messages), [stoppedMessage])
    });
  }
};
/**
 * Handler for stop message use case
 */

export var handleStopMessageUseCase = {
  name: STOP_MESSAGE_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      stopMessageStatus: RequestStatus.EXECUTE
    });
  },
  success: function success(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      stopMessageStatus: RequestStatus.SUCCESS
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      stopMessageStatus: RequestStatus.ERROR,
      error: action.error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      stopMessageStatus: RequestStatus.RESET
    });
  }
};
/**
 * Handler for adding attachments
 */

export var handleAddAttachments = {
  name: ADD_ATTACHMENTS,
  executing: function executing(state, action) {
    var newAttachments = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      attachments: [].concat(_toConsumableArray(state.attachments || []), _toConsumableArray(newAttachments))
    });
  }
};
/**
 * Handler for removing an attachment
 */

export var handleRemoveAttachment = {
  name: REMOVE_ATTACHMENT,
  executing: function executing(state, action) {
    var attachmentId = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      attachments: (state.attachments || []).filter(function (a) {
        return a.id !== attachmentId;
      })
    });
  }
};
export var handleClearAttachments = {
  name: CLEAR_ATTACHMENTS,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      attachments: []
    });
  }
};
/**
 * Handler for creating AI attachment files use case
 */

export var handleCreateAiAttachmentFilesUseCase = {
  name: CREATE_AI_ATTACHMENT_FILES_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      createAiAttachmentFilesStatus: RequestStatus.EXECUTE
    });
  },
  success: function success(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      createAiAttachmentFilesStatus: RequestStatus.SUCCESS,
      createAiAttachmentFilesOutput: action.payload
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      createAiAttachmentFilesStatus: RequestStatus.ERROR,
      error: action.error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      createAiAttachmentFilesStatus: RequestStatus.RESET,
      createAiAttachmentFilesOutput: null
    });
  }
};
/**
 * Handler for validate public file URL use case
 */

export var handleValidatePublicFileUrlUseCase = {
  name: VALIDATE_PUBLIC_FILE_URL_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      validatePublicFileUrlStatus: RequestStatus.EXECUTE
    });
  },
  success: function success(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      validatePublicFileUrlStatus: RequestStatus.SUCCESS,
      validatePublicFileUrlOutput: action.payload
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      validatePublicFileUrlStatus: RequestStatus.ERROR,
      error: action.error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      validatePublicFileUrlStatus: RequestStatus.RESET,
      validatePublicFileUrlOutput: null
    });
  }
};
/**
 * Handler for uploading conversation files use case
 */

export var handleUploadConversationFilesUseCase = {
  name: UPLOAD_CONVERSATION_FILES_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      uploadConversationFilesStatus: RequestStatus.EXECUTE
    });
  },
  success: function success(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      uploadConversationFilesStatus: RequestStatus.SUCCESS,
      uploadConversationFilesOutput: action.payload
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      uploadConversationFilesStatus: RequestStatus.ERROR,
      error: action.error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      uploadConversationFilesStatus: RequestStatus.RESET,
      uploadConversationFilesOutput: null
    });
  }
};
/**
 * Handler for creating a new conversation (reset chat)
 */

export var handleCreateConversationUseCase = {
  name: CREATE_CONVERSATION_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      getConversationsWithMessagesStatus: RequestStatus.EXECUTE
    });
  },
  success: function success(state, action) {
    var conversation = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      currentConversationId: conversation.id.toString(),
      messages: [],
      messagesNextToken: null,
      getConversationsWithMessagesStatus: RequestStatus.SUCCESS
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      getConversationsWithMessagesStatus: RequestStatus.ERROR,
      error: action.error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      getConversationsWithMessagesStatus: RequestStatus.RESET
    });
  }
};
export var aiChatHandlers = [handleGetConversationsWithMessagesUseCase, handleGetMessagesUseCase, handleGetPromptTemplatesUseCase, handleGetLlmProvidersUseCase, handleGetAIChatUsageWalletUseCase, handleGetAIChatAccountingSubscriptionUseCase, handleSendMessageUseCase, handleStopMessageUseCase, handleStreamChatUseCase, handleAppendAiMessageOnStreamDone, handleAddStoppedMessage, handleAddAttachments, handleRemoveAttachment, handleClearAttachments, handleCreateAiAttachmentFilesUseCase, handleValidatePublicFileUrlUseCase, handleUploadConversationFilesUseCase, handleCreateConversationUseCase];